<template>
  <div>
    <button @click="generate">导出</button>
  </div>
</template>

<script>
  import 'docxtemplater/build/docxtemplater.js'
  import 'pizzip/dist/pizzip.js'
  import 'pizzip/dist/pizzip-utils.js'
  import 'file-saver'

  export default {
    data() {
      return {
        wordData: {
          name: '导出word',
          nameList:[
              {
                  id:12323,
                  pri:1,
                  data:[
                      {
                          productName:"dsds",
                          productPrice: 1
                      },
                        {
                          productName:"sss",
                          productPrice: 2
                      }
                  ]
              },  {
                  id:4444,
                  pri:2,

                    data:[
                      {
                          productName:"aaaa",
                          productPrice: 11

                      }
                  ]
              }
          ]


        },
      }
    },

    methods: {
      // 导出word
      loadFile(url, callback) {
        PizZipUtils.getBinaryContent(url, callback);
      },
      generate() {
        var that = this;
        this.loadFile("http://freshgo123.com/template/word.docx", function (error, content) {
          if (error) {
            throw error
          };
          var zip = new PizZip(content);
          var doc = new window.docxtemplater().loadZip(zip)
          doc.setData({
            name: that.wordData.name,
            nameList:that.wordData.nameList
          });
          try {
            // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
            doc.render()
          } catch (error) {
            var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
            }
            console.log(JSON.stringify({
              error: e
            }));
            // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
            throw error;
          }
          var out = doc.getZip().generate({
            type: "blob",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          }) //Output the document using Data-URI
          saveAs(out, "output.docx")
        })
      },

    }
  }

</script>

<style scoped>

</style>